
      var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIcon24Star = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m12.757 18.006 4.54 2.876c.58.367 1.3-.18 1.128-.857l-1.312-5.159a.788.788 0 0 1 .256-.798l4.07-3.388c.535-.446.259-1.333-.428-1.378l-5.316-.345a.758.758 0 0 1-.652-.481L13.06 3.483a.749.749 0 0 0-1.4 0L9.677 8.476a.758.758 0 0 1-.652.481l-5.316.345c-.687.045-.963.932-.428 1.378l4.07 3.388a.787.787 0 0 1 .256.798L6.39 19.651c-.207.813.657 1.469 1.354 1.027l4.218-2.672a.74.74 0 0 1 .794 0z",
  stroke: "var(--theme-primary, #810ea9)",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))));

      const __svgRaw = "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\">\r\n    <g fill=\"none\" fill-rule=\"evenodd\">\r\n        <path d=\"M0 0h24v24H0z\"/>\r\n        <path d=\"m12.757 18.006 4.54 2.876c.58.367 1.3-.18 1.128-.857l-1.312-5.159a.788.788 0 0 1 .256-.798l4.07-3.388c.535-.446.259-1.333-.428-1.378l-5.316-.345a.758.758 0 0 1-.652-.481L13.06 3.483a.749.749 0 0 0-1.4 0L9.677 8.476a.758.758 0 0 1-.652.481l-5.316.345c-.687.045-.963.932-.428 1.378l4.07 3.388c.232.195.331.505.256.798L6.39 19.651c-.207.813.657 1.469 1.354 1.027l4.218-2.672a.74.74 0 0 1 .794 0z\" stroke=\"var(--theme-primary, #810ea9)\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\r\n    </g>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/icon-24-star.ddc6868e4cee9274d71426ce147006fa.svg"),
        {
          React: SvgIcon24Star,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      